// Utilities
import Analytics from './analyticsUtil'
import logger from '../utility/loggerUtil'

class MessagingUtil {
  /**
   * Updates CT identity and push/messaging settings for a customer (usually on login or link).
   */
  static async onLogin () {
    try {
      await Analytics.updateIdentity()
    } catch (e) {
      logger.error('Error on MessagingUtil.onLogin')
      logger.debug(e)
    }
  }
}

export default MessagingUtil
